"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _Seat = _interopRequireDefault(require("./Seat"));
var _RangeBar = _interopRequireDefault(require("./RangeBar"));
var _Control = _interopRequireDefault(require("./Control"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _ThemeService = require("../common/ThemeService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var replayImage = 'replay.png';
var positions = [[{
  cx: "45",
  cy: "6",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "15",
  cy: "15",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "74",
  cy: "15",
  seatPosition: "right",
  coinPosition: "middle"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "9",
  cy: "32",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "45",
  cy: "6",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "81",
  cy: "32",
  seatPosition: "right",
  coinPosition: "middle"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "13",
  cy: "50",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "20",
  cy: "11",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "68",
  cy: "11",
  seatPosition: "right",
  coinPosition: "top"
}, {
  cx: "74",
  cy: "50",
  seatPosition: "right",
  coinPosition: "middle"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "18",
  cy: "55",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "15",
  cy: "15",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "45",
  cy: "6",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "69",
  cy: "11",
  seatPosition: "right",
  coinPosition: "top"
}, {
  cx: "74",
  cy: "50",
  seatPosition: "right",
  coinPosition: "middle"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "22",
  cy: "60",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "9",
  cy: "32",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "25",
  cy: "9",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "50",
  cy: "6",
  seatPosition: "right",
  coinPosition: "top"
}, {
  cx: "74",
  cy: "15",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "74",
  cy: "50",
  seatPosition: "right",
  coinPosition: "middle"
}], [{
  cx: "36",
  cy: "65",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "13",
  cy: "50",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "15",
  cy: "15",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "36",
  cy: "6",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "54",
  cy: "6",
  seatPosition: "right",
  coinPosition: "top"
}, {
  cx: "74",
  cy: "15",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "74",
  cy: "50",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "54",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}], [{
  cx: "45",
  cy: "65",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "18",
  cy: "55",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "9",
  cy: "32",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "20",
  cy: "11",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "40",
  cy: "5",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "69",
  cy: "56",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "81",
  cy: "36",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "74",
  cy: "19",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "58",
  cy: "6",
  seatPosition: "right",
  coinPosition: "top"
}], [{
  cx: "13",
  cy: "50",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "9",
  cy: "32",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "15",
  cy: "15",
  seatPosition: "left",
  coinPosition: "middle"
}, {
  cx: "36",
  cy: "6",
  seatPosition: "left",
  coinPosition: "top"
}, {
  cx: "36",
  cy: "65",
  seatPosition: "left",
  coinPosition: "bottom"
}, {
  cx: "54",
  cy: "65",
  seatPosition: "right",
  coinPosition: "bottom"
}, {
  cx: "74",
  cy: "50",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "81",
  cy: "32",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "74",
  cy: "15",
  seatPosition: "right",
  coinPosition: "middle"
}, {
  cx: "54",
  cy: "6",
  seatPosition: "right",
  coinPosition: "top"
}]];
var tableImage = '/tableCarpet.png';
var baseUrl = "/images/handReplay/PartyPoker/";
var boosterImages = {
  gold: {
    amount: "gold_booster_amount_2px.png",
    normal: "gold_booster_2px.png"
  },
  silver: {
    amount: "silver_booster_amount_2px.png",
    normal: "silver_booster_2px.png"
  },
  bronze: {
    amount: "bronze_booster_amount_2px.png",
    normal: "bronze_booster_2x.png"
  }
};
var baseUrlForAll = "/images/handReplay/";
var ReplayTable = /*#__PURE__*/function (_Component) {
  _inherits(ReplayTable, _Component);
  var _super = _createSuper(ReplayTable);
  function ReplayTable(props) {
    var _this;
    _classCallCheck(this, ReplayTable);
    _this = _super.call(this, props);
    _this.getCurrencySymbol = function (currency) {
      console.log("getCurrencySymbol..........", currency);
      var currenciesList = [{
        key: 'USD',
        code: "$"
      }, {
        key: 'EUR',
        code: "\u20AC"
      }, {
        key: 'GBP',
        code: "\xA3"
      }, {
        key: 'CAD',
        code: "C".concat("$")
      }, {
        key: 'RUB',
        code: "\u20BD"
      }, {
        key: 'DKK',
        code: "K".concat("r").concat(".")
      }, {
        key: 'GEL',
        code: "\u20BE"
      }];
      var currencyObj = currenciesList.filter(function (obj) {
        return currency === obj.key;
      });
      if (currencyObj.length > 0) return currencyObj[0].code;else return "$";
    };
    _this.setPlayerPosition = function () {
      var playerList = [];
      var newPlayerList = [];
      if (_this.props.slide.players) {
        if (positions && positions.length > 1 && positions[_this.props.slide.players.length - 2] && positions[_this.props.slide.players.length - 2].length > 0) {
          playerList.push(_toConsumableArray(positions[_this.props.slide.players.length - 2]));
        }
        _this.props.slide.players.map(function (p, index) {
          var position = playerList[0];
          newPlayerList.push(_objectSpread(_objectSpread({}, p), position[index]));
        });
        _this.setState({
          playerList: [].concat(newPlayerList)
        });
        _this.forceUpdate();
      }
    };
    _this.state = {
      playerList: [],
      cards: [],
      lowEndChips: [0.50, 0.25, 0.10, 0.05, 0.01],
      highEndChips: [1000000000, 500000000, 100000000, 25000000, 5000000, 1000000, 500000, 100000, 25000, 5000, 1000, 500, 100, 25, 5, 1],
      coinsList: [],
      ritCardList: [],
      role: [],
      fromClient: JSON.parse(localStorage.getItem('fromClient', false)),
      loggedInType: localStorage.getItem('loggedInType')
    };
    return _this;
  }
  _createClass(ReplayTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.setPlayerPosition();
      this.setState({
        role: localStorage.getItem("userRole") ? JSON.parse(localStorage.getItem("userRole")) : []
      });
      if (localStorage.getItem("loggedInType") === "Danskespil") {
        baseUrl = "/images/handReplay/Danskespil/";
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        if (nextProps.slide.isRIT) {
          var ritCards = nextProps.slide.ritCards != null ? nextProps.slide.ritCards.split(',') : [];
          if (nextProps.slide.hiddenPot > 0) {
            var coins = this.props.getCoins(nextProps.slide.hiddenPot, this.state.highEndChips, this.state.lowEndChips);
            this.setState({
              coinsList: _toConsumableArray(coins),
              ritCardList: _toConsumableArray(ritCards)
            });
          } else if (nextProps.slide.hiddenPot <= 0) {
            this.setState({
              coinsList: [],
              ritCardList: _toConsumableArray(ritCards)
            });
          }
        } else {
          var cardList = nextProps.slide.cards != null ? nextProps.slide.cards.split(',') : [];
          if (nextProps.slide.hiddenPot > 0) {
            var _coins = this.props.getCoins(nextProps.slide.hiddenPot, this.state.highEndChips, this.state.lowEndChips);
            this.setState({
              coinsList: _toConsumableArray(_coins),
              cards: _toConsumableArray(cardList)
            });
          } else if (nextProps.slide.hiddenPot <= 0) {
            this.setState({
              coinsList: [],
              cards: _toConsumableArray(cardList)
            });
          }
        }
        this.setPlayerPosition();
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var themeColor = (0, _ThemeService.getColor)();
      var themeTextColor = (0, _ThemeService.getTextColor)();
      var themeDarkTextColor = (0, _ThemeService.getDarkTextColor)();
      var showTurnFlag = false;
      if (navigator) {
        var nav = navigator;
        // console.log("nav.appVersion",nav.appVersion)
        if (nav.appVersion.includes("Mobile") || nav.appVersion.includes("iPad") || nav.appVersion.includes("iPhone")) {
          showTurnFlag = true;
        } else {
          showTurnFlag = false;
        }
      }
      var _this$props = this.props,
        gameNo = _this$props.gameNo,
        game = _this$props.game,
        playerAlias = _this$props.playerAlias,
        gameTypeForTitle = _this$props.gameTypeForTitle,
        isShareDialogOpen = _this$props.isShareDialogOpen,
        closeShareDialog = _this$props.closeShareDialog,
        openShareDialog = _this$props.openShareDialog,
        partitionDate = _this$props.partitionDate,
        accountName = _this$props.accountName,
        smallBlind = _this$props.smallBlind,
        bigBlind = _this$props.bigBlind,
        ReplayerShareDialog = _this$props.ReplayerShareDialog,
        slideIndex = _this$props.slideIndex,
        slideLength = _this$props.slideLength,
        booster = _this$props.booster,
        boosterAmount = _this$props.boosterAmount,
        boosterType = _this$props.boosterType;
      return /*#__PURE__*/_react["default"].createElement("div", null, ReplayerShareDialog && isShareDialogOpen && gameNo && gameNo !== "" && this.state.role.indexOf('PLAYER') > -1 && /*#__PURE__*/_react["default"].createElement(ReplayerShareDialog, {
        game: game,
        gameNo: gameNo,
        playerAlias: playerAlias,
        selectedHandList: this.props.selectedHandList,
        isMultipleHands: this.props.selectedHandCount < 2 ? false : this.props.isMultipleHands,
        gameTypeForTitle: gameTypeForTitle,
        isOpen: isShareDialogOpen,
        onClose: closeShareDialog,
        partitionDate: partitionDate,
        accountName: accountName,
        smallBlind: smallBlind,
        bigBlind: bigBlind,
        slideIndex: slideIndex,
        slideLength: slideLength,
        loggedInType: this.state.loggedInType
      }), this.state.showModal && this.props.gameType != '' && this.props.gameType === 'Spin' && /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        query: "(max-width: 768px)",
        maxWidth: 768
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "missonmodal spinModal ",
        style: {
          paddingLeft: '18px',
          paddingRight: '18px',
          touchAction: "manipulation"
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: function onClick() {
          _this2.setState({
            showModal: false
          });
        },
        className: "btn btnHalo myError_CloseBtn",
        style: {
          backgroundColor: themeColor
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        "data-e2e": "close",
        className: "centre centre_closebtn",
        name: "fas fa-times",
        style: {
          color: themeTextColor
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modalContent  respPadding spin-error-modal "
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "",
        style: {
          paddingBottom: "11.42px"
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "my-errors-heading"
      }, "My Errors")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "replay-spin-errorBox"
      }, "In this hand you ".concat(this.props.handDtls.heroAction, " when it\u2019s best to ").concat(this.props.handDtls.optimalAction, ".")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "replay-spin-errorBox",
        style: {
          paddingTop: '17px'
        }
      }, "On average this will have cost you ".concat(this.props.handDtls.errorValue, " big blinds."))))), this.props.replayerScreen === 'desktop' ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: "absolute",
          right: 0,
          zIndex: 1,
          touchAction: "manipulation",
          top: "11px",
          paddingTop: this.props.isMultipleHands ? '10px' : '5px'
        }
      }, this.props.gameType != '' && this.props.gameType === 'Spin' && /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        query: "(max-width: 768px)",
        maxWidth: 768
      }, /*#__PURE__*/_react["default"].createElement("button", {
        "data-e2e": "shareButtonRC",
        className: "mutireplayer_shareHandButton my_error",
        style: {
          border: "1.1px solid ".concat(themeColor),
          marginTop: "0px"
        },
        onClick: function onClick() {
          _this2.setState({
            showModal: true
          });
        }
      }, "MY ERROR")), ReplayerShareDialog && /*#__PURE__*/_react["default"].createElement("span", null, " ", this.props.isMultipleHands ? /*#__PURE__*/_react["default"].createElement("span", {
        className: 'shareAndCloseReplayerWrapper' + (this.props.gameType === 'Spin' ? 'Spin' : '')
      }, /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        query: "(orientation: portrait)"
      }, function (matches) {
        return matches && showTurnFlag ? null : /*#__PURE__*/_react["default"].createElement("div", {
          "data-e2e": "shareButtonRC",
          className: "mutireplayer_shareHandButton",
          style: {
            marginTop: '0px'
          },
          onClick: openShareDialog
        }, _this2.props.selectedHandCount > 1 ? "Share ".concat(_this2.props.selectedHandCount, " Hands") : "Share 1 Hand");
      }), this.state.fromClient ? null : /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "closeButtonRC",
        className: "multiReplayer_crossButton",
        style: {
          marginTop: "0px"
        },
        onClick: this.props.onClose
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-times",
        style: {
          marginTop: "0px"
        }
      }))) : /*#__PURE__*/_react["default"].createElement("span", {
        className: 'shareAndCloseReplayerWrapper' + (this.props.gameType === 'Spin' ? 'Spin' : '')
      }, /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        query: "(orientation: portrait)"
      }, function (matches) {
        return matches && showTurnFlag ? null : /*#__PURE__*/_react["default"].createElement("div", {
          "data-e2e": "shareButtonRC",
          style: {
            marginTop: "0px"
          },
          className: "mutireplayer_shareHandButton",
          onClick: openShareDialog
        }, "SHARE HAND");
      }), this.state.fromClient ? null : /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "closeButtonRC",
        className: "multiReplayer_crossButton",
        style: {
          marginTop: "0px"
        },
        onClick: this.props.onClose
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-times",
        style: {
          marginTop: "0px"
        }
      }))))) : null, this.props.isMultipleHands ? null : /*#__PURE__*/_react["default"].createElement("img", {
        width: "3.5%",
        height: "3.5%",
        style: this.props.replayerScreen && this.props.replayerScreen === 'shared' ? {
          marginTop: "40px"
        } : null,
        className: "replay-class",
        onClick: this.props.refresh,
        src: baseUrl + replayImage
      }), /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        query: "(orientation: portrait)"
      }, function (matches) {
        return matches && showTurnFlag ? /*#__PURE__*/_react["default"].createElement("center", null, /*#__PURE__*/_react["default"].createElement("img", {
          style: {
            width: "35%",
            marginTop: "50%"
          },
          src: "/images/replayerElements/orientationCoverNew.png"
        }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h4", {
          style: {
            fontWeight: "bold",
            fontSize: "150%",
            color: "white"
          }
        }, "TURN YOUR DEVICE"), _this2.props.playStatus ? _this2.props.pause() : null) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "svgDiv",
          style: {
            touchAction: "manipulation"
          }
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          height: "100%",
          width: "100%"
        }, /*#__PURE__*/_react["default"].createElement("image", {
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          href: (0, _ThemeService.getImage)(baseUrlForAll, tableImage)
        }), _this2.props.slide.isRIT ? _this2.props.slide.hiddenPot > 0 ? /*#__PURE__*/_react["default"].createElement("svg", {
          width: "100%",
          height: "100%"
        }, /*#__PURE__*/_react["default"].createElement("rect", {
          x: "47%",
          y: "23.5%",
          width: "8%",
          height: "3%",
          rx: "10",
          fill: "black",
          fillOpacity: "0.4"
        }), /*#__PURE__*/_react["default"].createElement("text", {
          x: "51%",
          y: "25.5%",
          textAnchor: "middle",
          fill: "white"
        }, (gameTypeForTitle === "tournament" ? "" : _this2.getCurrencySymbol(_this2.props.currency)) + _this2.props.slide.pot), " ") : null : _this2.props.slide.hiddenPot > 0 ? /*#__PURE__*/_react["default"].createElement("svg", {
          width: "100%",
          height: "100%"
        }, /*#__PURE__*/_react["default"].createElement("rect", {
          x: "47%",
          y: "30%",
          width: "8%",
          height: "3%",
          rx: "10",
          fill: "black",
          fillOpacity: "0.4"
        }), /*#__PURE__*/_react["default"].createElement("text", {
          x: "51%",
          y: "32%",
          textAnchor: "middle",
          fill: "white"
        }, (gameTypeForTitle === "tournament" ? "" : _this2.getCurrencySymbol(_this2.props.currency)) + _this2.props.slide.pot), " ") : null, _this2.state.playerList.length > 0 ? _this2.state.playerList.map(function (p, index) {
          if (_this2.props.slide.action && _this2.props.slide.action.action === "ante") {
            p.name = _this2.props.slide.action.action;
            p.color = "yellow";
          } else {
            if (_this2.props.slide.action ? _this2.props.slide.action.actor === p.name : false) {
              if (p.hero) {
                p.name = "Hero";
              }
              p.name = _this2.props.slide.action.action;
              p.color = "yellow";
            } else {
              if (p.hero) {
                p.name = "Hero";
              }
              p.color = "white";
            }
          }
          return p.hero || (_this2.props.slide.action ? p.name === _this2.props.slide.action.action : false) ? /*#__PURE__*/_react["default"].createElement(_Seat["default"], {
            currency: _this2.props.currency,
            getCoins: _this2.props.getCoins,
            key: index,
            gameTypeForTitle: gameTypeForTitle,
            cardsLength: _this2.props.slide.cardsLength,
            color: p.color,
            player: p,
            playerName: p.name,
            action: _this2.props.slide.action ? _this2.props.slide.action.action : null,
            sequence: _this2.props.slide.action ? _this2.props.slide.action.sequence : null,
            showCards: _this2.props.slide.showCards,
            cashout_plyrs: _this2.props.slide.cashout_plyrs
          }) : /*#__PURE__*/_react["default"].createElement(_Seat["default"], {
            currency: _this2.props.currency,
            getCoins: _this2.props.getCoins,
            color: p.color,
            cardsLength: _this2.props.slide.cardsLength,
            key: index,
            player: p,
            gameTypeForTitle: gameTypeForTitle,
            action: _this2.props.action ? _this2.props.slide.action.action : null,
            playerName: "Player" + (index + 1),
            showCards: _this2.props.slide.showCards,
            cashout_plyrs: _this2.props.slide.cashout_plyrs
          });
        }) : null, /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
          query: "(max-width: 768px)",
          maxWidth: 768
        }, function (matches) {
          return matches ? /*#__PURE__*/_react["default"].createElement(_Control["default"], {
            cy: "0",
            width: "110",
            height: "100",
            stepBackward: _this2.props.stepBackward,
            isMultipleHands: _this2.props.isMultipleHands,
            replayImage: replayImage,
            selectedHandCount: _this2.props.selectedHandCount,
            currentReplayerHandIndex: _this2.props.currentReplayerHandIndex,
            prevHand: _this2.props.prevHand,
            nextHand: _this2.props.nextHand,
            refresh: _this2.props.refresh,
            replayerScreen: _this2.props.replayerScreen,
            stepForward: _this2.props.stepForward,
            pause: _this2.props.pause,
            play: _this2.props.play,
            playStatus: _this2.props.playStatus,
            stop: _this2.props.stop,
            isLastSlide: _this2.props.slide.isLastSlide ? true : false,
            isFirstSlide: _this2.props.slide.action ? false : true,
            zx: "-7%",
            zy: "0%"
          }) : /*#__PURE__*/_react["default"].createElement(_Control["default"], {
            cy: "0",
            width: "110",
            height: "100",
            stepBackward: _this2.props.stepBackward,
            isMultipleHands: _this2.props.isMultipleHands,
            replayImage: replayImage,
            selectedHandCount: _this2.props.selectedHandCount,
            currentReplayerHandIndex: _this2.props.currentReplayerHandIndex,
            prevHand: _this2.props.prevHand,
            nextHand: _this2.props.nextHand,
            refresh: _this2.props.refresh,
            replayerScreen: _this2.props.replayerScreen,
            stepForward: _this2.props.stepForward,
            pause: _this2.props.pause,
            play: _this2.props.play,
            playStatus: _this2.props.playStatus,
            stop: _this2.props.stop,
            isLastSlide: _this2.props.slide.isLastSlide ? true : false,
            isFirstSlide: _this2.props.slide.action ? false : true,
            zx: "-7%",
            zy: "0"
          });
        }), _this2.props.slide.isRIT ? _this2.state.cards.length > 0 && _this2.state.cards.map(function (card, index) {
          if (_this2.props.slide.highLightCard && !_this2.props.slide.isLastSlide) {
            if (_this2.props.slide.highLightCard.includes(card)) {
              return /*#__PURE__*/_react["default"].createElement("image", {
                x: 30 + index * 6 + "%",
                y: "27%",
                width: "12%",
                height: "12%",
                href: baseUrl + 'cards/' + card + '.png'
              });
            } else {
              return /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
                x: 30 + index * 6 + "%",
                y: "27%",
                width: "12%",
                height: "12%",
                href: baseUrl + 'cards/' + card + '.png',
                style: {
                  fill: "white",
                  opacity: "0.5"
                }
              }));
            }
          } else {
            return /*#__PURE__*/_react["default"].createElement("image", {
              x: 30 + index * 6 + "%",
              y: "27%",
              width: "12%",
              height: "12%",
              href: baseUrl + 'cards/' + card + '.png'
            });
          }
        }) : _this2.state.cards.length > 0 && _this2.state.cards.map(function (card, index) {
          if (_this2.props.slide.highLightCard) {
            if (_this2.props.slide.highLightCard.includes(card)) {
              return /*#__PURE__*/_react["default"].createElement("image", {
                x: 30 + index * 6 + "%",
                y: "35%",
                width: "12%",
                height: "12%",
                href: baseUrl + 'cards/' + card + '.png'
              });
            } else {
              return /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
                x: 30 + index * 6 + "%",
                y: "35%",
                width: "12%",
                height: "12%",
                href: baseUrl + 'cards/' + card + '.png',
                style: {
                  fill: "white",
                  opacity: "0.5"
                }
              }));
            }
          } else {
            return /*#__PURE__*/_react["default"].createElement("image", {
              x: 30 + index * 6 + "%",
              y: "35%",
              width: "12%",
              height: "12%",
              href: baseUrl + 'cards/' + card + '.png'
            });
          }
        }), _this2.props.slide.isRIT && _this2.state.ritCardList.length > 0 && _this2.state.ritCardList.map(function (card, index) {
          if (card === "") {
            return /*#__PURE__*/_react["default"].createElement("image", {
              x: 30 + index * 6 + "%",
              y: "40%",
              width: "12%",
              height: "12%",
              href: '/images/Dark_Card.png'
            });
          } else {
            if (_this2.props.slide.highLightCard && _this2.props.slide.isLastSlide) {
              if (_this2.props.slide.highLightCard.includes(card)) {
                return /*#__PURE__*/_react["default"].createElement("image", {
                  x: 30 + index * 6 + "%",
                  y: "40%",
                  width: "12%",
                  height: "12%",
                  href: baseUrl + 'cards/' + card + '.png'
                });
              } else {
                return /*#__PURE__*/_react["default"].createElement("svg", null, /*#__PURE__*/_react["default"].createElement("image", {
                  x: 30 + index * 6 + "%",
                  y: "40%",
                  width: "12%",
                  height: "12%",
                  href: baseUrl + 'cards/' + card + '.png',
                  style: {
                    fill: "white",
                    opacity: "0.5"
                  }
                }));
              }
            } else {
              return /*#__PURE__*/_react["default"].createElement("image", {
                x: 30 + index * 6 + "%",
                y: "40%",
                width: "12%",
                height: "12%",
                href: baseUrl + 'cards/' + card + '.png'
              });
            }
          }
        }), _this2.state.coinsList.length > 0 ? _this2.state.coinsList.map(function (coin, index) {
          return coin[index].map(function (value, i) {
            var afterDec = 0;
            if (parseInt(value) < 1) {
              afterDec = value.toString().split('.')[1];
            }
            return _this2.props.slide.isRIT ? parseInt(value) > 0 ? /*#__PURE__*/_react["default"].createElement("image", {
              key: i,
              x: 40 + index * 2.5 + "%",
              y: 54 - i * 0.3 + "%",
              width: "2.5%",
              height: "2.5%",
              href: baseUrl + 'chips/chipD' + value + '.png'
            }) : /*#__PURE__*/_react["default"].createElement("image", {
              key: i,
              x: 40 + index * 2.5 + "%",
              y: 54 - i * 0.3 + "%",
              width: "2.5%",
              height: "2.5%",
              href: baseUrl + 'chips/chipC' + afterDec + '.png'
            }) : parseInt(value) > 0 ? /*#__PURE__*/_react["default"].createElement("image", {
              key: i,
              x: 40 + index * 2.5 + "%",
              y: 50 - i * 0.3 + "%",
              width: "2.5%",
              height: "2.5%",
              href: baseUrl + 'chips/chipD' + value + '.png'
            }) : /*#__PURE__*/_react["default"].createElement("image", {
              key: i,
              x: 40 + index * 2.5 + "%",
              y: 50 - i * 0.3 + "%",
              width: "2.5%",
              height: "2.5%",
              href: baseUrl + 'chips/chipC' + afterDec + '.png'
            });
          });
        }) : null), (slideIndex === 0 || slideLength === slideIndex) && booster && booster === "Y" ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "booster-img"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          style: {
            height: '100%'
          },
          src: "/images/Booster/".concat(boosterImages[boosterType.toLowerCase()][slideLength === slideIndex ? "amount" : "normal"])
        }), slideLength === slideIndex && booster && booster === "Y" ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "booster-amount"
        }, /*#__PURE__*/_react["default"].createElement("span", null, "+$" + boosterAmount)) : '') : '', /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
          query: "(min-width: 769px)",
          minWidth: 769
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row",
          style: {
            margin: 0,
            padding: 0
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-12 col-sm-7 col-md-7 col-lg-7 adjustErrorBox",
          style: {
            padding: 0
          }
        }, _this2.props.gameType != '' && _this2.props.gameType === 'Spin' && /*#__PURE__*/_react["default"].createElement("span", {
          className: "replayErrorBox-displayProp",
          style: {
            backgroundColor: 'white',
            paddingLeft: '19px',
            paddingRight: '19.33px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px 2px rgba(0,0,0,0.09)',
            marginTop: '31px',
            marginBottom: '32px',
            paddingBottom: '11px',
            position: 'absolute'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "my-game-analysis",
          style: {
            paddingTop: "11.7px"
          }
        }, "My Errors"), /*#__PURE__*/_react["default"].createElement("div", {
          className: "replay-spin-errorBox"
        }, "In this hand you ".concat(_this2.props.handDtls.heroAction, " when it\u2019s best to ").concat(_this2.props.handDtls.optimalAction, ".")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "replay-spin-errorBox",
          style: {
            paddingTop: '17px'
          }
        }, "On average this will have cost you ".concat(_this2.props.handDtls.errorValue, " big blinds.")))))), /*#__PURE__*/_react["default"].createElement(_RangeBar["default"], {
          getRangeBarValue: _this2.props.getRangeBarValue
        }));
      }));
    }
  }]);
  return ReplayTable;
}(_react.Component);
var _default = ReplayTable;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReplayTable/ReplayTable.js
 ** module id = 2383
 ** module chunks = 0
 **/